import { BrandsByCode } from '../../services/utils/Brands';

export const checkTotalDealCount = (vehicle, dealData) => {
  let totalCount =
    ((vehicle.stockType.toUpperCase() === 'SAMPLE' && !vehicle.isAvailableForReplacementLease) ||
    vehicle.isUsed
      ? 0
      : dealData.lease) +
    (vehicle.stockType.toUpperCase() === 'SAMPLE' && !vehicle.isAvailableForReplacementFinance
      ? 0
      : dealData.finance) +
    (vehicle.stockType.toUpperCase() === 'SAMPLE' && !vehicle.isAvailableForReplacementCash
      ? 0
      : dealData.cash);
  return totalCount;
};

export const checkDealTypes = (bulkData) => {
  const pathParts = location.pathname.split('/');
  const urlType = pathParts[2];

  const dealTypesSelected = {
    hasCashDeals: false,
    hasFinanceDeals: false,
    hasLeaseDeals: false,
    multipleSelected: false,
  };
  dealTypesSelected.hasLeaseDeals = bulkData.dealerList.some(
    (el) =>
      el.dealerId === bulkData.selectedDealer[0] && (el.dealType === 'Lease' || el.dealType === 1),
  );
  dealTypesSelected.hasFinanceDeals = bulkData.dealerList.some(
    (el) =>
      el.dealerId === bulkData.selectedDealer[0] &&
      (el.dealType === 'Finance' || el.dealType === 2),
  );
  dealTypesSelected.hasCashDeals = bulkData.dealerList.some(
    (el) =>
      el.dealerId === bulkData.selectedDealer[0] && (el.dealType === 'Cash' || el.dealType === 4),
  );
  if (urlType.toUpperCase() === 'ALL') {
    dealTypesSelected.multipleSelected = atLeastTwoAreSelected(
      dealTypesSelected.hasLeaseDeals,
      dealTypesSelected.hasCashDeals,
      dealTypesSelected.hasFinanceDeals,
    );
  }
  return dealTypesSelected;
};

export const updateVehicleData = (vehicle, selectedDealer) => {
  const usedString = ['Used', 'used', 'U', 'USED', 'preowned', 'PREOWNED', 'Pre-owned'];
  vehicle.stockType = vehicle.isGhostVehicle
    ? 'Sample'
    : vehicle.stockType != null
      ? vehicle.stockType
      : 'N/A';

  if (vehicle.ageDays === null || vehicle.ageDays === -1) {
    vehicle.ageDays = 0;
  }

  if (vehicle.miles === null) {
    vehicle.miles = 0;
  }

  const vehicleStockType = vehicle.stockType.toLowerCase();
  // n / u should be new
  vehicle.stockType =
    vehicleStockType == 'n' || vehicleStockType == 'new'
      ? 'New'
      : vehicleStockType == 'u' || vehicleStockType == 'used'
        ? 'Pre-owned'
        : vehicle.stockType;

  // vehicle.vehicleType = vehicle.stockType == 'Sample' ? 'Sample' : vehicle.vehicleType;
  vehicle.isAvailableForReplacementLease =
    vehicle.isAvailableForReplacementLease === null || vehicle.isAvailableForReplacementLease;
  vehicle.isAvailableForReplacementCash =
    vehicle.isAvailableForReplacementCash === null || vehicle.isAvailableForReplacementCash;
  vehicle.isAvailableForReplacementFinance =
    vehicle.isAvailableForReplacementFinance === null || vehicle.isAvailableForReplacementFinance;
  vehicle.areAllNotApplicableForReplacement =
    !vehicle.isAvailableForReplacementLease &&
    !vehicle.isAvailableForReplacementCash &&
    !vehicle.isAvailableForReplacementFinance;
  const brandName =
    vehicle.brandName === 'Gmc' || vehicle.brandName === 'Mini' || vehicle.brandName == 'Infiniti'
      ? vehicle.brandName.toUpperCase()
      : vehicle.brandName != null && vehicle.brandName != ''
        ? vehicle.brandName
        : 'N/A';
  vehicle.make = brandName;
  vehicle.isOffBrand = !selectedDealer.includes(getByName(brandName));
  vehicle.isCurrentOffBrandVehicle = selectedDealer.includes('OB');
  vehicle.isUsed = usedString.includes(vehicle.stockType);
  return vehicle;
};

export const submitChangesCalculation = (submitChangeModalData) => {
  const tempData = {
    done: [],
    remaining: [],
  };

  const payload = {
    RequestResource: {},
    amVehicleId: submitChangeModalData.vehicle.amVehicleId,
    chromeId: submitChangeModalData.vehicle.chromeId,
    closedDealIds: [],
    isAllDealType: submitChangeModalData.isAllDealType,
    replacementVin: submitChangeModalData.vehicle.vin || null,
  };
  let remainingTotal = 0;
  if (submitChangeModalData.bulkData.isAllRowsSelected) {
    let leaseDeal = 0;
    let financeDeal = 0;
    let cashDeal = 0;

    const eligibleDealType = [];
    submitChangeModalData.bulkData.dealerList.forEach((e) => {
      if (e.dealerId === submitChangeModalData.bulkData.selectedDealer[0]) {
        if (e.dealType === 1) {
          if (
            (submitChangeModalData.vehicle.isAvailableForReplacementLease &&
              !submitChangeModalData.vehicle.isUsed) ||
            submitChangeModalData.vehicle.stockType.toUpperCase() === 'NEW'
          ) {
            leaseDeal = e.dealsCount;
            eligibleDealType.push(e.dealType);
          } else {
            remainingTotal += e.dealsCount;
            tempData.remaining.push(e);
          }
        }
        if (e.dealType === 2) {
          if (
            submitChangeModalData.vehicle.stockType.toUpperCase() !== 'SAMPLE' ||
            submitChangeModalData.vehicle.isAvailableForReplacementFinance
          ) {
            financeDeal = e.dealsCount;
            eligibleDealType.push(e.dealType);
          } else {
            remainingTotal += e.dealsCount;
            tempData.remaining.push(e);
          }
        }
        if (e.dealType === 4) {
          if (
            submitChangeModalData.vehicle.stockType.toUpperCase() !== 'SAMPLE' ||
            submitChangeModalData.vehicle.isAvailableForReplacementCash
          ) {
            cashDeal = e.dealsCount;
            eligibleDealType.push(e.dealType);
          } else {
            remainingTotal += e.dealsCount;
            tempData.remaining.push(e);
          }
        }
      }
    });
    payload.RequestResource = submitChangeModalData.bulkData.RequestResource;
    payload.RequestResource = {
      ...payload.RequestResource,
      DealerId: submitChangeModalData.bulkData.selectedDealer[0],
      EligibleDealType: eligibleDealType,
    };
  } else {
    submitChangeModalData.bulkData.dealerList.forEach((e) => {
      if (e.dealType.toLowerCase() === 'lease') {
        if (
          (submitChangeModalData.vehicle.isAvailableForReplacementLease &&
            !submitChangeModalData.vehicle.isUsed) ||
          submitChangeModalData.vehicle.stockType.toUpperCase() === 'NEW'
        ) {
          tempData.done.push(e.closedDealId);
        } else {
          tempData.remaining.push(e);
        }
      }
      if (e.dealType.toLowerCase() === 'cash') {
        if (
          submitChangeModalData.vehicle.stockType.toUpperCase() !== 'SAMPLE' ||
          submitChangeModalData.vehicle.isAvailableForReplacementCash
        ) {
          tempData.done.push(e.closedDealId);
        } else {
          tempData.remaining.push(e);
        }
      }
      if (e.dealType.toLowerCase() === 'finance') {
        if (
          submitChangeModalData.vehicle.stockType.toUpperCase() !== 'SAMPLE' ||
          submitChangeModalData.vehicle.isAvailableForReplacementFinance
        ) {
          tempData.done.push(e.closedDealId);
        } else {
          tempData.remaining.push(e);
        }
      }
    });
    payload.closedDealIds = tempData.done;
  }
  return { tempData, payload, remainingTotal };
};

const atLeastTwoAreSelected = (
  hasLeaseDeals: boolean,
  hasCashDeals: boolean,
  hasfinanceDeals: boolean,
) => {
  return (hasLeaseDeals && (hasCashDeals || hasfinanceDeals)) || (hasCashDeals && hasfinanceDeals);
};

const getAll = () => {
  return BrandsByCode;
};

const getByName = (name: string) => {
  return getAll().find((x) => x.name.toLowerCase() === name.toLowerCase()).code;
};
